import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Kojaro = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 42 32"
      {...rest}
      fill={fill}
    >
      <path
        fill="#3D85B7"
        d="M6 0L32 7.863 25.953 11zM31.778 8L34.372 12.71 32.475 16.786 37.547 16.786 39.251 17.855 42 18.33 39.251 19.24 19 23 25.699 11.206z"
        transform="translate(-588.000000, -1697.000000) translate(588.000000, 1697.000000)"
      />
      <path
        fill="#3D85B7"
        d="M22 18L16.046 19.12 0 24.981 14.731 22.331 3.248 32 19.216 22.629z"
        transform="translate(-588.000000, -1697.000000) translate(588.000000, 1697.000000)"
      />
      <path
        fill="#F90"
        d="M39 19l-20 3.914c9.05.248 14.537-.04 16.464-.865C37.39 21.225 38.569 20.21 39 19z"
        transform="translate(-588.000000, -1697.000000) translate(588.000000, 1697.000000)"
      />
    </svg>
  );
};

Kojaro.displayName = 'Kojaro';
